import { z } from 'zod';

/**
 * Creates a Zod schema for request integration form validation
 * @param t Translation function
 * @returns Zod schema for organization form
 */
export const createRequestFormSchema = (t: (key: string, options?: any) => string) =>
  z.object({
    tools: z.array(
      z.object({
        name: z.string().min(1, {
          message: t('authenticated.onboarding.integrations:validation.requiredField'),
        }),
      })
    ),
  });

export type RequestFormValues = z.infer<ReturnType<typeof createRequestFormSchema>>;
